"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_helmet_1 = require("react-helmet");
const CustomHelmet = ({ title = '', meta = [], link = [], script = [], noscript = [], base = [], style = [], }) => (<react_helmet_1.Helmet>
    <title>{title}</title>
    {meta === null || meta === void 0 ? void 0 : meta.map((m, index) => (<meta key={index} {...m}/>))}
    {link === null || link === void 0 ? void 0 : link.map((l, index) => (<link key={index} {...l}/>))}
    {script === null || script === void 0 ? void 0 : script.map((s, index) => (<script key={index} {...s}/>))}
    {noscript === null || noscript === void 0 ? void 0 : noscript.map((ns, index) => (<noscript key={index} {...ns}/>))}
    {base === null || base === void 0 ? void 0 : base.map((b, index) => (<base key={index} {...b}/>))}
    {style === null || style === void 0 ? void 0 : style.map((st, index) => (<style key={index} {...st}/>))}
  </react_helmet_1.Helmet>);
exports.default = CustomHelmet;
